"use strict";
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TertiaryButton = void 0;
var React = require("react");
var TertiaryButton_styles_1 = require("./TertiaryButton.styles");
var TertiaryButton = function (_a) {
    var Caption = _a.Caption, Disabled = _a.Disabled, OnClick = _a.OnClick, FullWidth = _a.FullWidth;
    return (React.createElement(TertiaryButton_styles_1.Button, { disabled: Disabled, onClick: OnClick && !Disabled ? OnClick.bind(_this) : null, Width: FullWidth ? "100%" : "auto" },
        React.createElement(TertiaryButton_styles_1.CaptionContainer, null, Caption)));
};
exports.TertiaryButton = TertiaryButton;
